var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("sc-grid", {
    attrs: {
      name: "sc-psl-table-all",
      data: _vm.psls,
      total: _vm.pslsCount,
      loading: _vm.loading,
      "default-sort-column": "created",
      "default-sort-direction": "desc",
      "has-backend-sorting": false
    },
    on: { pagination: _vm.onPaginate },
    scopedSlots: _vm._u([
      {
        key: "table-columns",
        fn: function(ref) {
          var props = ref.props
          return [
            _c(
              "sc-table-column",
              {
                attrs: { label: "ID PLP Intelipost", field: "id", sortable: "" }
              },
              [
                _vm.redirectIsEnabled(props.row.localized_status)
                  ? _c("a", { attrs: { href: _vm.getUrl(props.row) } }, [
                      _vm._v("\n        " + _vm._s(props.row.id) + "\n      ")
                    ])
                  : _c("span", [
                      _vm._v("\n        " + _vm._s(props.row.id) + "\n      ")
                    ])
              ]
            ),
            _vm._v(" "),
            _c(
              "sc-table-column",
              {
                attrs: {
                  label: "ID PLP Transportadora",
                  field: "psl_id_in_logistic_provider",
                  sortable: ""
                }
              },
              [
                props.row.psl_id_in_logistic_provider
                  ? _c("span", [
                      _vm._v(
                        "\n        " +
                          _vm._s(props.row.psl_id_in_logistic_provider) +
                          "\n      "
                      )
                    ])
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _c(
              "sc-table-column",
              {
                attrs: {
                  label: "ID PLP Embarcadora",
                  field: "shippers",
                  sortable: ""
                }
              },
              [
                _c(
                  "ul",
                  _vm._l(props.row.shippers, function(shipper) {
                    return _c("li", { key: shipper.id }, [
                      _vm._v("\n          " + _vm._s(shipper.id) + "\n        ")
                    ])
                  })
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "sc-table-column",
              {
                attrs: {
                  label: "Status",
                  field: "localized_status",
                  sortable: ""
                }
              },
              [
                _c(
                  "sc-tooltip",
                  {
                    attrs: {
                      position: "is-right",
                      type: "is-danger",
                      multilined: "",
                      active:
                        props.row.localized_status ===
                        "UNAVAILABLE_LOGISTIC_PROVIDER",
                      label:
                        "A transportadora estava indisponível. Mas não se preocupe, faremos um a nova tentativa em alguns minutos"
                    }
                  },
                  [
                    _c("sc-localized-status", {
                      attrs: { status: props.row.localized_status }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "sc-table-column",
              {
                attrs: {
                  label: "Data de criação",
                  field: "created",
                  sortable: ""
                }
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm._f("date")(props.row.created, "DD/MM/YYYY - HH:mm")
                    ) +
                    "\n    "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "sc-table-column",
              {
                attrs: {
                  label: "Volumes (Qtd)",
                  field: "shipment_order.volumes.length",
                  sortable: ""
                }
              },
              [
                props.row.shipment_order.volumes
                  ? [
                      _vm._v(
                        "\n        " +
                          _vm._s(props.row.shipment_order.volumes.length) +
                          "\n      "
                      )
                    ]
                  : _vm._e()
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "sc-table-column",
              {
                attrs: {
                  label: "Métodos de entrega",
                  field: "delivery_method_names",
                  sortable: ""
                }
              },
              [
                _c(
                  "ul",
                  _vm._l(props.row.logistic_provider.delivery_methods, function(
                    deliveryMethod
                  ) {
                    return _c("li", { key: deliveryMethod.id }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(deliveryMethod.name) +
                          "\n        "
                      )
                    ])
                  })
                )
              ]
            ),
            _vm._v(" "),
            props.row.warehouse
              ? _c(
                  "sc-table-column",
                  {
                    attrs: {
                      label: "Origem",
                      field: "warehouse.official_name",
                      sortable: ""
                    }
                  },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(props.row.warehouse.official_name) +
                        "\n    "
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "sc-table-column",
              { attrs: { label: "Ações" } },
              [_c("sc-actions-menu", { attrs: { row: props.row } })],
              1
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ab8d6672", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ab8d6672","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-psl/features/list/components/sc-psl-list-tables/ScPslListTableAll.vue
// module id = null
// module chunks = 